import { Preferences } from '@capacitor/preferences'
import { isReactive, toRaw } from 'vue'
import getBrowser from '@/plugins/browser-polyfill'

export default {
  configure: Preferences.configure,
  get: async key => {
    if (BUILD_TARGET === 'extension') {
      const value = await (await getBrowser()).storage.local.get(key)
      if (value[key]) return value[key]
    }

    return Preferences.get({ key }).then(i => JSON.parse(i.value)?.value ?? null)
  },
  set: async (key, value) => {
    if (BUILD_TARGET === 'extension') {
      // convert reactive objects to plain objects, or firefox extension storage gets messed up :))
      const normalizedValue = (value && isReactive(value)) ? toRaw(value) : value
      return (await getBrowser()).storage.local.set({ [key]: normalizedValue })
    }

    return Preferences.set({ key, value: JSON.stringify({ value }) })
  },
  remove: async key => {
    if (BUILD_TARGET === 'extension') {
      return (await getBrowser()).storage.local.remove(key)
    }

    return Preferences.remove({ key })
  },
}
